import { render } from "./GiftcardChristmas.vue?vue&type=template&id=8283fe46&scoped=true"
import script from "./GiftcardChristmas.vue?vue&type=script&lang=js"
export * from "./GiftcardChristmas.vue?vue&type=script&lang=js"

import "./GiftcardChristmas.vue?vue&type=style&index=0&id=8283fe46&lang=postcss&scoped=true"

import exportComponent from "/usr/src/app/vue-goparity/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8283fe46"]])

export default __exports__